import ImageBlock from './Image';
import MediaBlock from './Media';
import SlidesBlock from './Slides';
import TextBlock from './Text';
import LogoBlock from './Logo';
import VideoBlock from './Video';
import TextWithImageBlock from './TextWithImage';
import LinkBlock from './Link';
import ResourceBlock from './Resource';

const blocks = {
    logo: LogoBlock,
    image: ImageBlock,
    media: MediaBlock,
    slides: SlidesBlock,
    text: TextBlock,
    textwithimage: TextWithImageBlock,
    video: VideoBlock,
    link: LinkBlock,
    resource: ResourceBlock,
};

const normalize = str => str.toLowerCase().replace(/[^A-Za-z0-9_-]+/gi, '');

const getBlockComponent = (name) => {
    const normalizedName = normalize(name);
    const blockKey = Object.keys(blocks).find(key => normalize(key) === normalizedName);
    return typeof blockKey !== 'undefined' ? blocks[blockKey] : null;
};

export {
    LogoBlock,
    ImageBlock,
    MediaBlock,
    SlidesBlock,
    TextBlock,
    TextWithImageBlock,
    VideoBlock,
    LinkBlock,
    ResourceBlock,
    getBlockComponent,
};

export default blocks;



// WEBPACK FOOTER //
// ./components/blocks/index.js